import { useQuery } from "@tanstack/react-query";
import { useAuth } from "~/store";
import { authServices } from "./auth.services";
import { AUTH_KEYS } from "./auth.keys";

export const useGetMe = () => {
  const { tokens, isAuth } = useAuth();
  return useQuery({
    queryKey: AUTH_KEYS.GET_ME(isAuth),
    queryFn: authServices.getMe,
    enabled: !!tokens?.accessToken,
  });
};
